import { generate } from '@/utils/request';
const config = {
    prefix: '/spur/v1/{organizationId}/quotation',
    items: [
      { key: 'getApplyPageList', url: '/pageList', method: 'POST', loadingHide: true },
      // 新增报价单
      { key: 'addQuotation', url: '/addApply', method: 'POST' },
      // 获取汇率
      { key: 'getExchangeRate', url: '/getExchangeRate', method: 'GET'},
      //  获取报价单详情
      { key: 'getQuotationDetail', url: '/detail/{id}', method: 'GET'},
      // 废弃报价单
      { key: 'abandonQuotation', url: '/cancel', method: 'POST'},
      // 编辑报价单
      { key: 'editQuotation', url: '/update', method: 'POST'},
      // 删除报价单
      { key: 'deleteQuotation', url: '/delete' + '?id={id}', method: 'DELETE'},
      // 审核报价单
      { key: 'auditQuotation', url: '/audit', method: 'PATCH'},
      // 转采购单前的校验
      { key: 'checkQuotation', url: '/quotationToPurchase', method: 'POST'},
      // 报价数据信息历史查询
      { key: 'getQuotationHistoryPageList', url: '/quotationPageList', method: 'POST', loadingHide: true },
      // 获取运输成本
      { key: 'getCalcShippingCost', url: '/calcShippingCost', method: 'GET'}
    ]
};

export default {
    ...generate(config),
};
